// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-language-popup__logo{display:inline-block;vertical-align:middle;max-height:1em}.czt-language-popup__logo--kzn{max-height:2.5em}", ""]);
// Exports
module.exports = exports;
